import vopayApi from '@/services/api.config';
import { useToken } from '@/providers/Token.provider';
import axios from 'axios';

type LinkWalletParams = {
  RecipientID: string;
  RecipientName: string;
  IframeKey: string;
} & (
  | {
      walletType: 'paypal';
      recipientType: 'EMAIL' | 'PHONE' | 'PAYPAL_ID';
    }
  | {
      walletType: 'venmo';
      recipientType: 'EMAIL' | 'PHONE' | 'USER_HANDLE';
    }
);

export default function useLinkDigitalWallet() {
  const source = axios.CancelToken.source();
  const { token } = useToken();
  const bearer = token?.JWT || '';
  const { api } = vopayApi;

  async function linkWallet(req: LinkWalletParams) {
    if (req.walletType === 'paypal') {
      const res = await api.postLinkPaypal(
        {
          ...req,
          PayPalRecipientType: req.recipientType,
        },
        bearer,
        source,
      );
      if (!res.Success || !res.PayPalToken) {
        console.error('Failed to link PayPal wallet:', res.ErrorMessage);
        throw new Error(res.ErrorMessage || 'Failed to link PayPal wallet');
      }
      return res.PayPalToken;
    }
    if (req.walletType === 'venmo') {
      const res = await api.postLinkVenmo(
        {
          ...req,
          VenmoRecipientType: req.recipientType,
        },
        bearer,
        source,
      );
      if (!res.Success || !res.VenmoToken) {
        console.error('Failed to link Venmo wallet:', res.ErrorMessage);
        throw new Error(res.ErrorMessage || 'Failed to link Venmo wallet');
      }
      return res.VenmoToken;
    }
  }
  return {
    linkWallet,
  };
}
